module.exports = __webpack_public_path__ + "img/ponzone.5f249d39.jpg";